/**
 * @generated SignedSource<<69a88a91f9363f650eeaae1bc21db80f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GLOBAL_FILTER_CONTEXT = "PROJECTS" | "PEOPLE" | "TASKS" | "TIME_REGS" | "INVOICES" | "SKILLS" | "LABELS" | "PLACEHOLDERS" | "RESOURCES" | "%future added value";
export type GLOBAL_FILTER_FIELD = "COMPANY_TASK_ID" | "NAME" | "STATUS" | "PROJECT_STATUS" | "PROJECT_GROUP_STATUS" | "PROJECT_PHASE" | "PROJECT_SPRINT" | "PROJECT_GROUP_SPRINT" | "DESCRIPTION" | "REMAINING" | "TIME_REGS" | "FORECAST" | "TASK_APPROVED" | "START_DATE" | "START_DATE_PROJECT" | "END_DATE" | "END_DATE_PROJECT" | "START_DATE_TIME_REG" | "PHASE_TIME_REG" | "END_DATE_TIME_REG" | "PROJECT_TIME_REG" | "ROLE_TIME_REG" | "TEAM_TIME_REG" | "DEPARTMENT_TIME_REG" | "INTERNAL_TIME_REG" | "TIME_OFF_TIME_REG" | "BILLABLE_TIME_REG" | "NON_PROJECT_TIME_REG" | "NON_PHASE_TIME_REG" | "NON_TASK_TIME_REG" | "NON_CLIENT_TIME_REG" | "NON_DEPARTMENT_TIME_REG" | "NON_ROLE_TIME_REG" | "NON_SPRINT_TIME_REG" | "PERSON_TIME_REG" | "CLIENT_TIME_REG" | "SPRINT_TIME_REG" | "LABEL_TIME_REG" | "TASK_TIME_REG" | "CREATED_AT" | "WITH_TIME_REG" | "WITH_TASKS" | "TASK" | "TASK_LEVEL" | "UPDATED_AT" | "SET_DONE_AT" | "ASSIGNED" | "ASSIGNED_SELF" | "OWNER" | "FOLLOWER" | "LABELS" | "PROJECT_LABELS" | "ROLE" | "PROJECT" | "PROJECT_PERSON" | "CLIENT" | "PROJECT_STAGE" | "BUG" | "BLOCKED" | "BILLABLE" | "HIGH_PRIORITY" | "STARRED" | "RECENT_TIME" | "RECENT_TASK_ACTIVITY" | "RECENT_ACTIVITY" | "PHASE_CATEGORY" | "SPRINT_CATEGORY" | "DEADLINE" | "TEAM_MEMBER" | "TEAM" | "PERMISSION_LEVEL" | "CLIENT_GUEST_USERS" | "DEPENDENCIES" | "SUB_TASKS" | "TASK_HIERARCHY" | "DEPARTMENT" | "PERSON" | "NO_CONTACT" | "APPROVAL_STATUS" | "INTERNAL_TIME" | "TIME_OFF" | "PROJECT_FOLLOWER" | "PROJECT_OWNER" | "PROJECT_BUDGET_TYPE" | "PROJECT_DEFAULT_PERIOD_BUDGET_TYPE" | "RATE_CARD" | "CONTACT" | "INVOICED" | "SKILL" | "PRIORITY_LEVEL" | "PROJECT_GROUP" | "PROGRAM" | "FILTER_BY_TIME_REG_SETTINGS" | "BILL_TO" | "BILL_FROM" | "PROJECT_MANUAL_PROGRESS" | "RETAINER_PERIOD" | "PROJECT_WIN_CHANCE" | "%future added value";
export type GLOBAL_FILTER_LOGICAL_OPERATOR = "AND" | "OR" | "%future added value";
export type GLOBAL_FILTER_OPERATOR = "IS" | "IS_NOT" | "IS_ALL" | "IS_NOT_ALL" | "CONTAINS" | "CONTAINS_NOT" | "GREATER" | "GREATER_OR_EQUAL" | "LESS" | "LESS_OR_EQUAL" | "IN" | "NOT_IN" | "ALL_IN" | "NOT_ALL_IN" | "%future added value";
export type TaskSearchQueryType = {
  filters?: ReadonlyArray<GlobalSearchFilterType | null> | null;
};
export type GlobalSearchFilterType = {
  field?: GLOBAL_FILTER_FIELD | null;
  operator?: GLOBAL_FILTER_OPERATOR | null;
  value?: ReadonlyArray<string | null> | null;
  context?: GLOBAL_FILTER_CONTEXT | null;
  filters?: ReadonlyArray<GlobalSearchFilterType | null> | null;
  logicalOperator?: GLOBAL_FILTER_LOGICAL_OPERATOR | null;
};
export type MonthByMonthDownload_Query$variables = {
  startYear?: number | null;
  startMonth?: number | null;
  startDay?: number | null;
  endYear?: number | null;
  endMonth?: number | null;
  endDay?: number | null;
  searchQuery: TaskSearchQueryType;
  pageSize: number;
  cursor?: string | null;
};
export type MonthByMonthDownload_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"MonthByMonthDownload_viewer">;
  } | null;
};
export type MonthByMonthDownload_Query = {
  variables: MonthByMonthDownload_Query$variables;
  response: MonthByMonthDownload_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDay"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endMonth"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endYear"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageSize"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchQuery"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDay"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startMonth"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startYear"
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "utilization_report_month_by_month_person_csv_loader"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"utilization_report_month_by_month_person_csv_loader\")"
},
v11 = {
  "kind": "Variable",
  "name": "endDay",
  "variableName": "endDay"
},
v12 = {
  "kind": "Variable",
  "name": "endMonth",
  "variableName": "endMonth"
},
v13 = {
  "kind": "Variable",
  "name": "endYear",
  "variableName": "endYear"
},
v14 = {
  "kind": "Variable",
  "name": "searchQuery",
  "variableName": "searchQuery"
},
v15 = {
  "kind": "Variable",
  "name": "startDay",
  "variableName": "startDay"
},
v16 = {
  "kind": "Variable",
  "name": "startMonth",
  "variableName": "startMonth"
},
v17 = {
  "kind": "Variable",
  "name": "startYear",
  "variableName": "startYear"
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MonthByMonthDownload_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "args": [
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor"
              },
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              {
                "kind": "Variable",
                "name": "pageSize",
                "variableName": "pageSize"
              },
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "MonthByMonthDownload_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v8/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "MonthByMonthDownload_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "after",
                    "variableName": "cursor"
                  },
                  {
                    "kind": "Literal",
                    "name": "aggregateLevel",
                    "value": "MONTH"
                  },
                  {
                    "kind": "Literal",
                    "name": "aggregates",
                    "value": [
                      "forecastBillableUtilization",
                      "forecastBillableUtilizationWin",
                      "forecastBillableUtilizationSoft",
                      "forecastBillableUtilizationSoftWin",
                      "forecastBillableUtilizationHard",
                      "forecastResourceUtilization",
                      "forecastResourceUtilizationWin",
                      "forecastResourceUtilizationSoft",
                      "forecastResourceUtilizationSoftWin",
                      "forecastResourceUtilizationHard",
                      "forecastBillableUtilizationTaskAndAllocationsCombined",
                      "forecastBillableUtilizationTaskAndAllocationsCombinedWin",
                      "forecastBillableUtilizationTaskAndAllocationsCombinedSoft",
                      "forecastBillableUtilizationTaskAndAllocationsCombinedSoftWin",
                      "forecastBillableUtilizationTaskAndAllocationsCombinedHard",
                      "forecastResourceUtilizationTaskAndAllocationsCombined",
                      "forecastResourceUtilizationTaskAndAllocationsCombinedWin",
                      "forecastResourceUtilizationTaskAndAllocationsCombinedSoft",
                      "forecastResourceUtilizationTaskAndAllocationsCombinedSoftWin",
                      "forecastResourceUtilizationTaskAndAllocationsCombinedHard"
                    ]
                  },
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "pageSize"
                  },
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/)
                ],
                "concreteType": "PersonTypeConnection",
                "kind": "LinkedField",
                "name": "resourceBasedPersons",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PersonTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Person",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v18/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "firstName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lastName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "profilePictureId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "aggregatedResourceNumbers",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v18/*: any*/)
            ],
            "storageKey": null
          },
          (v18/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "11c301fa6c1d00091f2b1bf5763bd93e",
    "id": null,
    "metadata": {},
    "name": "MonthByMonthDownload_Query",
    "operationKind": "query",
    "text": "query MonthByMonthDownload_Query(\n  $startYear: Int\n  $startMonth: Int\n  $startDay: Int\n  $endYear: Int\n  $endMonth: Int\n  $endDay: Int\n  $searchQuery: TaskSearchQueryType!\n  $pageSize: Int!\n  $cursor: String\n) {\n  viewer {\n    actualPersonId\n    component(name: \"utilization_report_month_by_month_person_csv_loader\")\n    ...MonthByMonthDownload_viewer_2Tl75\n    id\n  }\n}\n\nfragment MonthByMonthDownload_viewer_2Tl75 on Viewer {\n  company {\n    resourceBasedPersons(first: $pageSize, after: $cursor, searchQuery: $searchQuery, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: MONTH, aggregates: [\"forecastBillableUtilization\", \"forecastBillableUtilizationWin\", \"forecastBillableUtilizationSoft\", \"forecastBillableUtilizationSoftWin\", \"forecastBillableUtilizationHard\", \"forecastResourceUtilization\", \"forecastResourceUtilizationWin\", \"forecastResourceUtilizationSoft\", \"forecastResourceUtilizationSoftWin\", \"forecastResourceUtilizationHard\", \"forecastBillableUtilizationTaskAndAllocationsCombined\", \"forecastBillableUtilizationTaskAndAllocationsCombinedWin\", \"forecastBillableUtilizationTaskAndAllocationsCombinedSoft\", \"forecastBillableUtilizationTaskAndAllocationsCombinedSoftWin\", \"forecastBillableUtilizationTaskAndAllocationsCombinedHard\", \"forecastResourceUtilizationTaskAndAllocationsCombined\", \"forecastResourceUtilizationTaskAndAllocationsCombinedWin\", \"forecastResourceUtilizationTaskAndAllocationsCombinedSoft\", \"forecastResourceUtilizationTaskAndAllocationsCombinedSoftWin\", \"forecastResourceUtilizationTaskAndAllocationsCombinedHard\"]) {\n      edges {\n        node {\n          id\n          firstName\n          lastName\n          profilePictureId\n          aggregatedResourceNumbers\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "a09c78b917fe8a4ba0dd90edf620e39b";

export default node;
